import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import RegisterForm from "@/components/auth/RegisterForm";
import { loginFailure, loginStart, loginSuccess } from "@/redux/auth/authSlice";
import { authService } from "@/services/authService";
import { RootState } from "@/store";
import { RegisterCredentials } from "@/types/auth";

export default function RegisterPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { error, isLoading } = useSelector((state: RootState) => state.auth);

  const handleRegister = async (credentials: RegisterCredentials) => {
    try {
      dispatch(loginStart());

      // Use real API registration service
      const response = await authService.register(credentials);

      if (response.token && response.user) {
        dispatch(loginSuccess({ token: response.token, user: response.user }));

        // Debug: log user role for troubleshooting
        console.log("User role:", response.user.role);

        // Redirect based on user role
        if (
          [
            "delivery",
            "DeliveryDriver",
            "driver",
            "scooter",
            "ScooterDriver",
            "VehicleDriver",
          ].includes(response.user.role)
        ) {
          console.log("Redirecting to driver dashboard");
          navigate("/driver/dashboard", { replace: true });
        } else if (["admin", "manager", "staff"].includes(response.user.role)) {
          console.log("Redirecting admin/manager/staff to home");
          navigate("/", { replace: true }); // Redirect to home page until general dashboard is created
        } else {
          console.log(
            "Redirecting other roles to home, role was:",
            response.user.role,
          );
          navigate("/", { replace: true }); // Redirect to home page for other roles
        }
      }
    } catch (err) {
      let message = "Registration failed";
      if (err instanceof Error) {
        message = err.message;
      }
      dispatch(loginFailure(message));
    }
  };

  const handleGoogleLogin = async () => {
    try {
      dispatch(loginStart());

      // TODO: Implement Google OAuth registration
      await new Promise((resolve) => setTimeout(resolve, 1500));

      const mockUser = {
        createdAt: new Date().toISOString(),
        email: "newuser@gmail.com",
        emergency_contact_name: "",
        emergency_contact_phone: "",
        emergency_contact_relationship: "",
        emergency_contact_surname: "",
        firstName: "Alex",
        full_name: "Alex Johnson",
        id: "4",
        isEmailVerified: true,
        lastLoginAt: new Date().toISOString(),
        lastName: "Johnson",
        name: "Alex Johnson",
        phone: "",
        profileImage: "",
        role: "user" as const,
      };

      const mockToken = "mock-google-register-jwt-token-" + Date.now();

      dispatch(loginSuccess({ token: mockToken, user: mockUser }));
      navigate("/", { replace: true });
    } catch (err) {
      dispatch(loginFailure("Google registration failed"));
    }
  };

  return (
    <RegisterForm
      error={error || undefined}
      isLoading={isLoading}
      onGoogleLogin={handleGoogleLogin}
      onSubmit={handleRegister}
    />
  );
}
